export const columns = [
  {
    type: "link",
    name: "name",
    label: "NDR Name",
    searchable: true,
    style: { width: "15rem" },
    stickyLeft: true,
    show: true
  },
  {
    type: "string",
    name: "order_number",
    label: "Order Number",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    type: "string",
    name: "tracking_number",
    label: "Tracking Number",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    type: "multi_select",
    name: "merchant_name",
    label: "Merchant",
    searchable: true,
    options: [],
    style: { width: "15rem" },
    show: true
  },
  {
    type: "multi_select",
    name: "courier_name",
    label: "Courier",
    searchable: true,
    options: [],
    style: { width: "15rem" },
    show: true
  },
  {
    type: "string",
    name: "consignee_name",
    label: "Consignee Name",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    type: "string",
    name: "consignee_phone",
    label: "Consignee Phone",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    type: "string",
    name: "consignee_backup_phone",
    label: "Backup Phone",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    type: "string",
    name: "city",
    label: "City",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    type: "string",
    name: "non_delivery_reason",
    label: "NDR Reason",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    type: "multi_select",
    name: "status",
    label: "NDR Status",
    searchable: true,
    options: [],
    style: { width: "15rem" },
    show: true
  },
  {
    type: "multi_select",
    name: "action",
    label: "Action",
    searchable: true,
    options: [],
    style: { width: "10rem" },
    show: true
  },
  {
    type: "multi_select",
    name: "action_taken_by",
    label: "Action Taken By",
    searchable: true,
    options: [],
    style: { width: "12rem" },
    show: true
  },
  {
    type: "multi_select",
    name: "order_status",
    label: "Order Status",
    searchable: true,
    options: [],
    style: { width: "12rem" },
    show: true
  },
  {
    type: "multi_select",
    name: "order_sub_status",
    label: "Order Sub Status",
    searchable: true,
    options: [],
    style: { width: "14rem" },
    show: true
  },
  {
    type: "multi_select",
    name: "courier_notification_status",
    label: "Courier Notification",
    searchable: true,
    options: [],
    style: { width: "15rem" },
    show: true
  },
  {
    type: "date_range",
    name: "redelivery_date",
    label: "Redelivery Date",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    type: "date_range",
    name: "action_requested_date",
    label: "Action Requested Date",
    searchable: true,
    style: { width: "17rem" },
    show: true
  },
  {
    type: "date_range",
    name: "created_at",
    label: "Created At",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    type: "date_range",
    name: "updated_at",
    label: "Updated At",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    name: "actions",
    label: "",
    type: "actions",
    style: { width: "8rem" },
    searchable: false,
    stickyRight: true,
    show: true
  },
];